import { isReferenceCallMission } from '../constants/missionTypes';

type MissionAvailabilityInput = {
  fromDate?: Date | string | null;
  toDate?: Date | string | null;
  missionFrequency?: string | null;
  missionTypeID?: number | bigint | null;
  isDeleted?: number | boolean | null;
  isDraft?: number | boolean | null;
  isLive?: number | boolean | null;
  isScheduled?: number | boolean | null;
};

const toValidDate = (value?: Date | string | null) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const startOfUtcDay = (date: Date) =>
  new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 0, 0, 0, 0));

const endOfUtcDay = (date: Date) =>
  new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59, 999));

export const hasMissionStarted = (mission: MissionAvailabilityInput, now: Date = new Date()) => {
  const fromDate = toValidDate(mission.fromDate);
  if (!fromDate) return true;
  return startOfUtcDay(fromDate) <= now;
};

// gloss
export const isMissionExpired = (mission: MissionAvailabilityInput, now: Date = new Date()) => {
  if (isReferenceCallMission(mission.missionTypeID == null ? null : Number(mission.missionTypeID))) return false;
  const toDate = toValidDate(mission.toDate);
  if (!toDate) return false;

  return endOfUtcDay(toDate) < now;
};

export const isMissionAvailableNow = (mission: MissionAvailabilityInput, now: Date = new Date()) => {
  if (mission.isDeleted) return false;
  if (mission.isDraft) return false;
  if (mission.isLive !== undefined && mission.isLive !== null && !mission.isLive) return false;
  return hasMissionStarted(mission, now) && !isMissionExpired(mission, now);
};
